<!-- <div class="block-resizable" 
      ngxResizable
      cdkDrag> 
      <div class="block-resizable-handle" cdkDragHandle>
        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
          <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
          <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
      </div>
      <app-filemanager-sidebar></app-filemanager-sidebar>
    </div> -->
<mat-card class="chat-app cardWithShadow overflow-hidden height-content-player" [class.pinned]="pinnedState()">
  <mat-sidenav-container
  #sidenavContainer
  autosize
    [ngClass]="{
      'side-panel-opened': sidePanelOpened,
      'side-panel-closed': !sidePanelOpened,
      'side-panel-pinned': pinnedState()
    }">
     @if(filemanagerMode ==='sidebar'){
        <mat-sidenav
        class="resizable sidenav-noscroll" 
          [mode]="sidebarMode()"
          [(opened)]="sidePanelOpened"
          (openedChange)="onOpenedChange($event)">
          <app-filemanager-sidebar></app-filemanager-sidebar>
        </mat-sidenav>
      }
        <mat-sidenav
          position="end"
          [mode]="isOver() ? 'over' : 'side'"
          [opened]="rightPanelOpened"
          (open)="rightPanelOpened = true"
          (close)="rightPanelOpened = false">
          <app-support-sidebar-room [uuid]="connectionId" [room]="room"></app-support-sidebar-room>
        </mat-sidenav>
    
    <mat-sidenav-content class="bg-white"
    [ngClass]="{
      'side-panel-pinned': pinnedState()
    }">

      <mat-toolbar class="chat-right-panel call-toolbar d-flex align-items-center b-b-1 gap-8">
        <img
          [src]="avatar_url"
          width="44"
          height="44"
          class="rounded-circle call-avatar"
          alt=""/>
        <div class="call-title">
          @if (technician) {
            <strong>{{ room.name }}</strong>
            <span>{{ technician.name }} {{ technician.lastname }}</span>
          }
        </div>
        <div class="call-actions">
          @if (filemanagerMode === 'sidebar') {
            <button type="button" class="xr-btn xr-btn--secondary" (click)="toggleSidePanel()"
                    [matTooltip]="'call.documents_tooltip' | translate" matTooltipPosition="below">
              <i-tabler name="folder" class="icon-20"></i-tabler>
              <span class="call-action-label">{{ 'call.documents' | translate }}</span>
            </button>
          }
          @if (filemanagerMode === 'modal') {
            <button type="button" class="xr-btn xr-btn--secondary" (click)="openFilemanager()"
                    [matTooltip]="'call.documents_tooltip' | translate" matTooltipPosition="below">
              <i-tabler name="folder" class="icon-20"></i-tabler>
              <span class="call-action-label">{{ 'call.documents' | translate }}</span>
            </button>
          }
          <button type="button" class="xr-btn xr-btn--secondary" (click)="rightPanelOpened = !rightPanelOpened"
                  [matTooltip]="'call.rooms_tooltip' | translate" matTooltipPosition="below">
            <i-tabler name="arrows-exchange" class="icon-20"></i-tabler>
            <span class="call-action-label">{{ 'call.rooms' | translate }}</span>
          </button>
        </div>
      </mat-toolbar>
      <!-- ------------------------------------------- -->
      <!--            video player content             -->
      <!-- ------------------------------------------- -->
      <ng-scrollbar style="height: calc(100vh - 182px)" class="position-relative">
        
        <mat-card-content class="chat-middle-box height-block-player">
          <app-web-rtc-communication
            #webRtcCommunication
           [backendUrl]="backendUrl"
            [connectionId]="connectionId"></app-web-rtc-communication>
        </mat-card-content>
        
      </ng-scrollbar>
      <!-- <mat-card-content class="chat-middle-box">
          <button (click)="loadLibrary()" [disabled]="loadLibraryDisabled">Load library</button>
          <button (click)="startBlur()" [disabled]="startBlurDisabled">Start blur</button>
          <button (click)="stopBlur()" [disabled]="!startBlurDisabled">Stop blur</button>
        </mat-card-content> -->
    </mat-sidenav-content>
  </mat-sidenav-container>
</mat-card>
